import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { Button, Modal } from 'antd';
import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';

interface OutStockTaskHeaderProps {
  action: OutofStock.Action;
  scenarioType: Marketing.StockoutScenarioType;
  platform: General.PlatformUpperCase;
}

export const OutStockTaskHeader = (props: OutStockTaskHeaderProps) => {
  const { action, scenarioType, platform } = props;
  const { t } = useTranslate();

  const title = useMemo(() => {
    const actionTitle = {
      create: t('marketing.新增'),
      update: t('marketing.编辑'),
      copy: t('marketing.复制'),
      view: t('aide.查看'),
    }[action];
    const label = platformLabelMap[toLowerCase(platform)];
    if (scenarioType === 'OUT_STOCK_REMINDER') {
      return `${actionTitle} - ${t('outofstock_menu2')} (${label})`;
    }

    if (scenarioType === 'ORDER_FOLLOWUP') {
      return `${actionTitle} - ${t('问题订单跟进')} (${label})`;
    }
  }, [action, scenarioType, platform, t]);

  return (
    <header className="flex justify-between flex-shrink-0 items-center h-[56px] px-6 bg-fill-0">
      <h2 className="text-base mb-0">{title}</h2>
      {scenarioType === 'OUT_STOCK_REMINDER' && (
        <Button
          type="link"
          onClick={() => {
            Modal.info({
              width: '50%',
              title: t('aide.使用说明'),
              content: (
                <ReactMarkdown
                  className={css`
                    code {
                      white-space: break-spaces;
                    }
                  `}
                  children={t('ViewOutStock.taskUserNote')}
                />
              ),
            });
          }}
        >
          {t('aide.使用说明')}
        </Button>
      )}
    </header>
  );
};
